import {
  HistoryElement,
  HistoryElementContent,
  HistoryElementContentModifications,
  HistoryElementContentType,
  HistoryResponse,
  StatusType
} from './history.model';
import { formatLocaleDateDayMonthYearHourMinute } from '../../../helpers/date.helper';
import { LESS_THAN_THOUSAND_CHAR_REGEX } from '../../../helpers/regexp.helper';
import { NoValue } from '@tribeauto/ngx-mobilite-material';

export interface StatusMappingResult {
  displayChip: boolean;
  statusType: StatusType;
}

export const toHistoryElement = (
  historyResponse: HistoryResponse,
  contentType: HistoryElementContentType | null,
  content?: HistoryElementContent[]
): HistoryElement => {
  return {
    creationDate: `${formatLocaleDateDayMonthYearHourMinute(historyResponse.creationDate)?.replace(',', '')}`,
    content,
    contentType
  };
};

export const toJsonHistoryElementContent = (data: { [key: string]: string[] }): HistoryElementContent[] => {
  const content: HistoryElementContent[] = [];

  const sectionKeys = Object.keys(data);

  for (const section of sectionKeys) {
    const modifications: HistoryElementContentModifications[] = [];

    for (const str of data[section]) {
      const colonIdx = str.indexOf(':');
      if (colonIdx === -1) {
        continue;
      }
      const field = str.slice(0, colonIdx).trim();

      const valuesStr = LESS_THAN_THOUSAND_CHAR_REGEX.exec(str.slice(colonIdx + 1).trim())?.[0] ?? '';
      const [oldValue, newValue] = valuesStr.split('->').map(v => v.trim());

      if (!newValue) {
        continue;
      }
      modifications.push({ field, oldValue, newValue });
    }

    content.push({ sectionTitle: section, modifications: modifications });
  }

  return content;
};

export const getStatusMappingResult = (subStatus: string | NoValue): StatusMappingResult => {
  if (!subStatus) {
    return { displayChip: false, statusType: StatusType.NONE };
  }

  const code = String(subStatus).trim();

  switch (true) {
    case code.startsWith('2'):
      return { displayChip: false, statusType: StatusType.NONE };
    case code.startsWith('3'):
      return { displayChip: true, statusType: StatusType.DECLINED };
    case code.startsWith('4'):
    case code.startsWith('6'):
    case code.startsWith('9'):
      return { displayChip: true, statusType: StatusType.UNDER_REVIEW };
    case code === '509':
    case code === '510':
    case code.startsWith('10'):
      return { displayChip: true, statusType: StatusType.FINAL };
    case code.startsWith('5'):
      return { displayChip: true, statusType: StatusType.CONDITIONAL_APPROVE };
    case code.startsWith('11'):
    case code.startsWith('12'):
    case code.startsWith('8'):
      return { displayChip: true, statusType: StatusType.FUNDED };
    case code.startsWith('7'):
      return { displayChip: true, statusType: StatusType.CLOSED };
    case code.startsWith('13'):
      return { displayChip: true, statusType: StatusType.TO_CANCEL };
    case code.startsWith('14'):
      return { displayChip: true, statusType: StatusType.NOT_FUNDABLE };
    default:
      return { displayChip: false, statusType: StatusType.ERROR };
  }
};
